import React from 'react'
import styled from 'styled-components'
import { device } from '../../../../config/theme/breakpoints';
import TitleSection from '../../../../components/title-section/title-section';
import image from '../../../../assets/img/item_service.png'

const GeneralCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerItem = styled(GeneralCenter)`
    width: 100%;
    background: #F2F2F2;
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 0px;
    flex-wrap: wrap;
    border-radius: 15px;
    align-items: flex-start;
`

const ContainerLeft = styled(GeneralCenter)`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;

    > div:nth-child(2){
        margin-top: 20px;
    }

    @media ${device.tablet}{
        width: 40%;
    }
`
const ContainerRight = styled.div`
    width: 100%;
    padding-left: 0; 

    @media ${device.tablet}{
        width: 58%;
        padding-left: 25px;
    }
`

const ContainerImage = styled.div`
    width: 100%;

    > img {
        width: 100%;
        border-radius: 10px 10px 100px 10px;
        border-bottom: 5px solid ${p => p.theme.palette.secondary.main};
    }
`

const ContainerText = styled.div`
    > h2, h4, p{
        margin: 0;
        margin-bottom: 5px;
    }

    > h4 {
        color: ${p => p.theme.palette.secondary.main}
    }

    > h2 {
        color: ${p => p.theme.palette.primary.main}
    }

    > p {
        color: ${p => p.theme.palette.text.black};
        font-size: 13px;
        margin-top: 20px;
    }
`
const customTitle = `
    margin-top: 20px;

    @media ${device.tablet}{
        margin-top: 0;
    }
`

const ItemAboutDetail: React.FunctionComponent = () => {
  return (
    <ContainerItem>
        <ContainerLeft>
            <ContainerImage>
                <img src={image} alt='bus' />
            </ContainerImage>
        </ContainerLeft>
        <ContainerRight>
            <ContainerText>
                <TitleSection preTitle='' title='Nosotros' className={customTitle}/>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
            </ContainerText>
        </ContainerRight>
    </ContainerItem>
  )
}

export default ItemAboutDetail;